import { NotificationByTypeDto, NotificationCategoryDto, NotificationDto } from '../models/notifications-grouped.model';

export const NOTIFICATIONS_DRAWER_FEATURE_KEY = 'notificationsDrawer';

export interface PendingDeleteEntry {
  notification: NotificationDto;
  typeCode: string;
  wasUnread: boolean;
  insertionIndex: number;
}

export interface NotificationTypePageState {
  nextPage: number;
  loadingMore: boolean;
  /** True when the type has fewer locally-loaded notifications than the server
   *  total — an effect should fetch the next page to fill the visible list. */
  needsRefill: boolean;
}

export interface NotificationsDrawerState {
  categories: NotificationCategoryDto[];
  totalCount: number;
  unreadCount: number;
  loading: boolean;
  error: string | null;
  typePageStates: Record<string, NotificationTypePageState>;
  expandedSections: Record<string, boolean>;
  deletingNotificationIds: number[];
  pendingDeletes: Record<number, PendingDeleteEntry>;
}

export const initialState: NotificationsDrawerState = {
  categories: [],
  totalCount: 0,
  unreadCount: 0,
  loading: false,
  error: null,
  typePageStates: {},
  expandedSections: {},
  deletingNotificationIds: [],
  pendingDeletes: {}
};

export function buildInitialExpandedSections(categories: NotificationCategoryDto[]): Record<string, boolean> {
  const result: Record<string, boolean> = {};
  categories.forEach(cat =>
    cat.notificationsByType.forEach((nt: NotificationByTypeDto) => {
      result[nt.notificationTypeCode] = true;
    })
  );
  return result;
}

export function buildInitialTypePageStates(
  categories: NotificationCategoryDto[]
): Record<string, NotificationTypePageState> {
  const result: Record<string, NotificationTypePageState> = {};
  categories.forEach(cat =>
    cat.notificationsByType.forEach((nt: NotificationByTypeDto) => {
      result[nt.notificationTypeCode] = {
        nextPage: 2,
        loadingMore: false,
        needsRefill: false
      };
    })
  );
  return result;
}
